import React, { forwardRef } from 'react';
import styles from './Button.module.css';

const Button = forwardRef(function Button({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  disabled = false,
  onClick,
  type = 'button',
  className = '',
}, ref) {
  const classNames = [
    styles.button,
    styles[variant],
    styles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={classNames}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
    </button>
  );
});

export default Button;
